export default function Footer() {
  const footerNav = [
    { label: "精选专题", href: "#index" },
    { label: "热播榜单", href: "#ranking" },
    { label: "最新动态", href: "#updates" },
    { label: "片单精选", href: "#cards" },
    { label: "常见问题", href: "#faq" },
    { label: "联系我们", href: "#contact" },
  ];

  return (
    <footer id="footer" className="relative w-full bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <a href="#hero" className="inline-flex items-center gap-2 text-xl font-heading text-foreground-950 mb-4">
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-movie-line text-primary-500 text-xl"></i>
              </span>
              春夜影院
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              一个专为夜晚观影爱好者打造的高清追剧平台。精选适合夜晚观看的电影与剧集，伴你度过每一个美好夜晚。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-weibo-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-bilibili-line text-sm"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-950 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2">
              {footerNav.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(item.href)?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-950 mb-4">专题分类</h3>
            <div className="flex flex-col gap-2">
              <a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector("#cards")?.scrollIntoView({ behavior: "smooth" }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">治愈系电影</a>
              <a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector("#cards")?.scrollIntoView({ behavior: "smooth" }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">深夜悬疑</a>
              <a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector("#cards")?.scrollIntoView({ behavior: "smooth" }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">浪漫爱情</a>
              <a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector("#cards")?.scrollIntoView({ behavior: "smooth" }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">经典重温</a>
              <a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector("#cards")?.scrollIntoView({ behavior: "smooth" }); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">独立佳作</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-950 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-500 mb-4">暂无合作伙伴信息</p>
            <h3 className="text-sm font-medium text-foreground-950 mb-2 mt-4">联系方式</h3>
            <a href="mailto:hello@springnightcinema.com" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">hello@springnightcinema.com</a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 春夜影院. 所有内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">使用条款</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}